import { useContext } from "react";
import { AppContext } from "../../contexts/app";
import { ACTIONS } from "../../contexts/app/actions";
import { themes } from "../../constants/themes";

const useTheme = () => {
  const { state, dispatch } = useContext(AppContext);

  const setTheme = (themeKey) => {
    dispatch({ type: ACTIONS.SET_THEME, value: themeKey });
  };

  const theme = themes[state.theme];

  return { theme, themeKey: state.theme, setTheme };
};

export default useTheme;
